module.exports = __webpack_public_path__ + "static/TangleTower8-acfdf6817c3f74f395b75a8de794962b.webp";